export enum MarketWatchPlatform {
  Standalone = 'standalone',
  BusinessManager = 'business-manager',
  Editor = 'editor',
}
